import useVuexModule from '@shared/composables/vuexModule.js'
import { acceptHMRUpdate, defineStore } from 'pinia'

// TODO: Partial implementation (ENG-2851)
export const useGlobalStore = defineStore('global', () => {
  const vuex = useVuexModule('global')

  return {
    ...vuex
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useGlobalStore, import.meta.hot))
